import React, { useContext } from "react";
import { LanguageContext } from "../components/LanguageContext";
import img from '../images/Farook.jpg';
import althaf from '../images/althaf.png';
import vahab from '../images/vahab.jpg';

const AboutUs = () => {
  const { language } = useContext(LanguageContext);

  const avatar = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2uLl8zBoK0_iM5pNwJAC8hQ2f68YKtlgc7Q&s"; 

  const staff = [
    {
      id: 1,
      name: "C.Md.Sohail Pasha",
      designation: language === "en" ? "CMW (Minorities Welfare Dept. of A.P)" : "سی ایم ڈبلیو (اقلیتی بہبود محکمہ آندھرا پردیش)",
      image: avatar,
    },
    {
      id: 2,
      name: "Shaik Amitab",
      designation: language === "en" ? "CMW (Minorities Welfare Dept. of A.P)" : "سی ایم ڈبلیو (اقلیتی بہبود محکمہ آندھرا پردیش)",
      image: avatar,
    },
    {
      id: 3,
      name: "Shaik Shabbir",
      designation: language === "en" ? "CMW (Minorities Welfare Dept. of A.P)" : "سی ایم ڈبلیو (اقلیتی بہبود محکمہ آندھرا پردیش)",
      image: avatar,
    },
    {
      id: 4,
      name: "Shaik Moulana Azad",
      designation: language === "en" ? "HOD, APSUA" : "ایچ او ڈی، اے پی ایس یو اے",
      image: avatar,
    },
    {
      id: 5,
      name: "Shaik Mohammad Althaf Hussain",
      designation: language === "en" ? "HOD, APSUA" : "ایچ او ڈی، اے پی ایس یو اے",
      image: althaf,
    },
    {
      id: 6,
      name: "Shaik Saida",
      designation: language === "en" ? "HOD, APSUA" : "ایچ او ڈی، اے پی ایس یو اے",
      image: avatar,
    },
    {
      id: 7,
      name: "Abdul Vahab",
      designation: language === "en" ? "HOD, APSUA" : "ایچ او ڈی، اے پی ایس یو اے",
      image: vahab,
    },
    {
      id: 8,
      name: "Syed Ismail",
      designation: language === "en" ? "HOD, APSUA" : "ایچ او ڈی، اے پی ایس یو اے",
      image: avatar,
    },
    {
      id: 9,
      name: "Shaik Jilani",
      designation: language === "en" ? "Office sub-ordinate (HOD, APSUA)" : "دفتر ماتحت (ایچ او ڈی، اے پی ایس یو اے)",
      image: avatar,
    },
    {
      id: 10,
      name: "Sk.Shaeena",
      designation: language === "en" ? "Office sub-ordinate (HOD, APSUA)" : "دفتر ماتحت (ایچ او ڈی، اے پی ایس یو اے)",
      image: avatar,
    },
  ];
  

  return (
    <>
      {/* Header Section */}
      <div className="relative">
        <div className="h-[300px] relative">
          <img 
            src="https://th-i.thgim.com/public/migration_catalog/article10456065.ece/alternates/FREE_1200/amaravathi"
            alt="About Us Header" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-blue-900/40">
            <div className="container mx-auto px-8 h-full flex items-center">
              <div className="max-w-2xl text-white">
                <h1 className="text-3xl md:text-5xl font-bold mb-4">
                  {language === "en" ? "About Us" : "ہمارے بارے میں"}
                </h1>
                <p className="text-lg md:text-xl">
                  {language === "en"
                    ? "Fostering Urdu Language and Literature in Andhra Pradesh"
                    : "آندھرا پردیش میں اردو زبان اور ادب کو فروغ دینا"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* History Section */}
      <section className="py-6 md:py-12 bg-gray-50">
        <div className="container mx-auto px-8">
          <h2 className="text-3xl font-bold text-blue-800 mb-6">
            {language === "en" ? "Our History" : "ہماری تاریخ"}
          </h2>
            <div>
            <p className="text-gray-600 mb-4">
              {language === "en"
                ? "The Urdu Academy is an Autonomous Body, constituted by the Government of Andhra Pradesh vide G.O.Ms. No.1466, Dated 31-12-1975, registered under A.P. (Andhra Pradesh Area) Public Societies Registration Act. After the state bifurcation, Andhra Pradesh State Urdu Academy has been registered under the A.P. Societies Registration Act, 2001."
                : "اردو اکیڈمی ایک خودمختار ادارہ ہے، جو حکومت آندھرا پردیش کے G.O.Ms. نمبر 1466، مورخہ 31-12-1975 کے تحت تشکیل دیا گیا ہے، اور آندھرا پردیش (آندھرا پردیش ایریا) پبلک سوسائٹیز رجسٹریشن ایکٹ کے تحت رجسٹرڈ ہے۔ ریاست کی تقسیم کے بعد، آندھرا پردیش اسٹیٹ اردو اکیڈمی کو آندھرا پردیش سوسائٹیز رجسٹریشن ایکٹ، 2001 کے تحت رجسٹرڈ کیا گیا ہے۔"}
            </p>
            <p className="text-gray-600 mb-4">
              {language === "en"
                ? "As per the bye-laws of the Academy, the policies & projects of the Academy and to fulfill the aims & objectives of the Academy are determined by the Board of Governors of the Academy. The area of activity of the Urdu Academy is limited to literary activities such as extending financial assistance for holding Seminars, Mushairas, etc., to Urdu organizations and agencies; and publication of Urdu manuscripts written by Urdu poets, writers, and linguists. Basically, Urdu Academy’s functioning, its schemes & projects are meant for the promotion & protection of Urdu language & literature and have nothing to do with minorities. Its activities are primarily literary & academic in nature and pertain to welfare."
                : "اکیڈمی کے بائی لاز کے مطابق، اکیڈمی کی پالیسیاں اور منصوبے اور اکیڈمی کے مقاصد اور اہداف کو پورا کرنے کے لیے اکیڈمی کے بورڈ آف گورنرز کے ذریعہ طے کیا جاتا ہے۔ اردو اکیڈمی کی سرگرمیوں کا دائرہ صرف ادبی سرگرمیوں تک محدود ہے، جیسے اردو تنظیموں اور اداروں کو سیمینارز، مشاعروں وغیرہ کے انعقاد کے لیے مالی مدد فراہم کرنا؛ اور اردو شعرا، ادیبوں اور ماہرین لسانیات کے لکھے ہوئے اردو مخطوطات کی اشاعت۔ بنیادی طور پر اردو اکیڈمی کی کارکردگی، اس کی اسکیمیں اور منصوبے اردو زبان و ادب کے فروغ اور تحفظ کے لیے ہیں اور اقلیتوں سے اس کا کوئی تعلق نہیں ہے۔ اس کی سرگرمیاں بنیادی طور پر ادبی اور تعلیمی نوعیت کی ہیں اور فلاح و بہبود سے متعلق ہیں۔"}
            </p>
          </div>
        </div>
      </section>

    {/* Leadership Section */}
    <section className="">
      <div className="container mx-auto px-8 bg-gray-50">
        <h2 className="text-3xl font-bold text-blue-800 mb-6 ">
          {language === "en" ? "Our Leadership" : "ہماری قیادت"}
        </h2>
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-6 relative mx-auto w-48 h-full rounded-full overflow-hidden">
            <img
              src={img}
              alt="Nasyam Mohammed Farooq"
              className="w-full h-full object-cover"
            />
          </div>
          <h3 className="text-2xl font-bold text-blue-800 mb-2">
            {language === "en" ? "Nasyam Mohammed Farooq" : "نسیم محمد فاروق"}
          </h3>
          <p className="text-yellow-400 font-semibold mb-4">
            {language === "en" 
              ? "Honorable Minority Minister Of Andhra Pradesh" 
              : "آندھرا پردیش کے معزز اقلیتی وزیر"}
          </p>
          {/* <p className="text-gray-600 mx-auto">
            {language === "en" 
              ? "Nasyam Mohammed Farooq (born 15 May 1950) is an Indian politician who is currently MLA of Nandyala Assembly Constituency from TDP elected in 2024 elections and served as the 9th chairman of the Andhra Pradesh Legislative Council. Farooq is a nominated member of the Andhra Pradesh Legislative Council and is a member of the TDP" 
              : "نسیم محمد فاروق (پیدائش 15 مئی 1950) ایک ہندوستانی سیاستدان ہیں جو فی الحال ٹی ڈی پی سے نندیال اسمبلی حلقے کے ایم ایل اے ہیں جو 2024 کے انتخابات میں منتخب ہوئے اور آندھرا پردیش لیجسلیٹو کونسل کے نویں چیئرمین کے طور پر خدمات انجام دے چکے ہیں۔ فاروق آندھرا پردیش لیجسلیٹو کونسل کے نامزد رکن ہیں اور ٹی ڈی پی کے رکن ہیں"}
          </p> */}
        </div>
      </div>
    </section>

    {/* Chairmen History Section */}
    <section className="py-6 md:py-12 bg-gray-50">
      <div className="container mx-auto px-8">
        <h2 className="text-3xl font-bold text-blue-800 mb-6">
          {language === "en" ? "Urdu Academy's Chairmen" : "اردو اکیڈمی کے چیئرمین"}
        </h2>
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg shadow">
            <thead className="bg-blue-800 text-white">
              <tr>
                <th className="px-6 py-3 text-left">
                  {language === "en" ? "S.No" : "نمبر"}
                </th>
                <th className="px-6 py-3 text-left">
                  {language === "en" ? "Year" : "سال"}
                </th>
                <th className="px-6 py-3 text-left">
                  {language === "en" ? "Chairman" : "چیئرمین"}
                </th>
              </tr>
            </thead>
            <tbody>
            <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">14</td>
                <td className="px-6 py-4">2025</td>
                <td className="px-6 py-4 font-medium">Mohammed Farooq Shubli</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">13</td>
                <td className="px-6 py-4">2021</td>
                <td className="px-6 py-4 font-medium">H. Nadeem Ahmed BE.,</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">12</td>
                <td className="px-6 py-4">2017</td>
                <td className="px-6 py-4 font-medium">S. Md. Noumaan</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">11</td>
                <td className="px-6 py-4">2006</td>
                <td className="px-6 py-4 font-medium">Raheemuddin Ansari</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">10</td>
                <td className="px-6 py-4">2003</td>
                <td className="px-6 py-4 font-medium">Ibrahim bin Abdullah Masqati</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">9</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">Syed Shah Noorulhaq Qadri</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">8</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">Ansar Baig</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">7</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">Syed Rahmat Ali</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">6</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">Jaleel Pasha</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">5</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">Dr. Shaikh Dade sahib</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">4</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">Mirza Waheed Ahmed Baig</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">3</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">Hafiz Abu Yousuf</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">M. Baga Reddy</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">1</td>
                <td className="px-6 py-4">1998</td>
                <td className="px-6 py-4 font-medium">Asif Pasha</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    {/* Directors/Secretaries History Section */}
    <section className="py-6 bg-gray-50">
      <div className="container mx-auto px-8">
        <h2 className="text-3xl font-bold text-blue-800 mb-6">
          {language === "en" ? "Urdu Academy's Director/Secretary" : "اردو اکیڈمی کے ڈائریکٹر/سیکرٹری"}
        </h2>
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg shadow">
            <thead className="bg-blue-800 text-white
            ">
              <tr>
                <th className="px-6 py-3 text-left">
                  {language === "en" ? "S.No" : "نمبر"}
                </th>
                <th className="px-6 py-3 text-left">
                  {language === "en" ? "Year" : "سال"}
                </th>
                <th className="px-6 py-3 text-left">
                  {language === "en" ? "Director/Secretary" : "ڈائریکٹر/سیکرٹری"}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">14</td>
                <td className="px-6 py-4">2026</td>
                <td className="px-6 py-4 font-medium">Janab D. Nijauddin, M.A.</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">13</td>
                <td className="px-6 py-4">2025</td>
                <td className="px-6 py-4 font-medium">Janab Shaik Mohd. Ghouse Peer, M.A, M.Phil.</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">12</td>
                <td className="px-6 py-4">2024</td>
                <td className="px-6 py-4 font-medium">Janab Dr. Mastan, M.sc P.hd.</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">11</td>
                <td className="px-6 py-4">2023</td>
                <td className="px-6 py-4 font-medium">Janab Shaik Mastan Vali, M.A., M.PEd., M.Phil.</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">10</td>
                <td className="px-6 py-4">2022</td>
                <td className="px-6 py-4 font-medium">Dr. N. Ayyub Hussain, MCA., MSW., M.Sc., M.Ed., M.Phil., Ph.D.</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">9</td>
                <td className="px-6 py-4">2021</td>
                <td className="px-6 py-4 font-medium">L. Abdul Khadir, B.E, M.I.E,</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">8</td>
                <td className="px-6 py-4">2018</td>
                <td className="px-6 py-4 font-medium">Sk. Shereen Begum, SP</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">7</td>
                <td className="px-6 py-4">2019</td>
                <td className="px-6 py-4 font-medium">Dr. Y. Ali Akbar Basha, M.A.,M.Phil., Ph.D., HDCM,B.L.</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">6</td>
                <td className="px-6 py-4">2019</td>
                <td className="px-6 py-4 font-medium">S.Md.Tajuddin Aref, B.E</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">5</td>
                <td className="px-6 py-4">2018</td>
                <td className="px-6 py-4 font-medium">Syed Mastan vali, B.Com., HDCM,</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">4</td>
                <td className="px-6 py-4">2018</td>
                <td className="px-6 py-4 font-medium">Dr.Mohammed Nisar Ahamed, M.A., M.Phil, Phd.,</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">3</td>
                <td className="px-6 py-4">2018</td>
                <td className="px-6 py-4 font-medium">K. Ramgopal, IAS</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">2018</td>
                <td className="px-6 py-4 font-medium">Praveen Kumar, IAS</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-6 py-4">1</td>
                <td className="px-6 py-4">2017</td>
                <td className="px-6 py-4 font-medium">Mohd Iqbal, IPS</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

      {/* Staff Section */}
      {/* <section className="py-6 md:py-12 bg-gray-50">
        <div className="container mx-auto px-8">
          <h2 className="text-3xl font-bold text-blue-800 mb-6">
            {language === "en" ? "Our Staff" : "ہمارا عملہ"}
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-lg shadow">
              <thead className="bg-blue-800 text-white">
                <tr>
                  <th className="px-6 py-3 text-left">
                    {language === "en" ? "Photo" : "تصویر"}
                  </th>
                  <th className="px-6 py-3 text-left">
                    {language === "en" ? "Name" : "نام"}
                  </th>
                  <th className="px-6 py-3 text-left">
                    {language === "en" ? "Designation" : "عہدہ"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {staff.map((member) => (
                  <tr key={member.id} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <img 
                        src={member.image} 
                        alt={member.name} 
                        className="w-12 h-12 rounded-full object-cover"
                      />
                    </td>
                    <td className="px-6 py-4 font-medium">{member.name}</td>
                    <td className="px-6 py-4 text-gray-600">{member.designation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default AboutUs;
